<template>
  <v-app>

    <!-- ══ FIXED HEADER ══ -->
    <div class="site-header">

      <!-- Top Bar -->
      <div class="top-bar">
        <span>Jinpara, Near Andh Apang Gaushala, Wankaner — Gujarat &nbsp;|&nbsp; તમારી કાર, અમારી જવાબદારી</span>
        <span>Mon–Sat, 9 AM – 8 PM &nbsp;|&nbsp; 9723638209, 9228238209</span>
      </div>

      <!-- Navbar -->
      <div class="navbar">
        <div class="navbar-left">
          <img src="@/assets/SKM.png" alt="SKM" class="nav-logo" />
          <div class="navbar-brand">
            <span class="brand-white">SHREE KHODIYAR&nbsp;</span><span class="brand-red">MOTORS</span>
          </div>
        </div>
        <div class="navbar-right">
          <router-link
            v-for="link in navLinks"
            :key="link.to"
            :to="link.to"
            class="nav-link"
            active-class="nav-link--active"
          >{{ link.label }}</router-link>
        </div>
      </div>

    </div>

    <!-- ══ CONTENT ══ -->
    <div class="site-content">
      <router-view />
    </div>

    <!-- ══ FOOTER ══ -->
    <div class="site-footer">
      <div class="footer-top">

        <!-- Col 1: Brand -->
        <div class="footer-brand">
          <img src="@/assets/SKM.png" alt="SKM" class="footer-logo" />
          <p class="footer-brand-desc">Car body work, painting &amp; detailing in Wankaner, Gujarat. Quality you can see, service you can trust.</p>
          <span class="footer-gujarati">તમારી કાર, અમારી જવાબદારી</span>
        </div>

        <!-- Col 2: Explore -->
        <div class="footer-col">
          <div class="footer-col-title">EXPLORE</div>
          <router-link to="/home" class="footer-link">Home</router-link>
          <router-link to="/services" class="footer-link">Services</router-link>
          <router-link to="/gallery" class="footer-link">Gallery</router-link>
          <router-link to="/contact" class="footer-link">Contact</router-link>
        </div>

        <!-- Col 3: Services -->
        <div class="footer-col">
          <div class="footer-col-title">SERVICES</div>
          <router-link to="/services" class="footer-link">Car Body Work</router-link>
          <router-link to="/services" class="footer-link">Car Painting</router-link>
          <router-link to="/services" class="footer-link">Detailing &amp; Coating</router-link>
          <router-link to="/services" class="footer-link">Insurance Claim Help</router-link>
        </div>

        <!-- Col 4: Contact -->
        <div class="footer-col">
          <div class="footer-col-title">GET IN TOUCH</div>
          <a href="tel:9723638209" class="footer-link">97236 38209</a>
          <a href="tel:9228238209" class="footer-link">92282 38209</a>
          <span class="footer-address">Street No. 14, Jinpara,<br>Wankaner – 363621</span>
          <span class="footer-hours">Mon–Sat · 9 AM – 8 PM</span>
        </div>

      </div>

      <div class="footer-bottom">
        <span class="footer-copy">&copy; 2026 Shree Khodiyar Motors. All rights reserved.</span>
        <span class="footer-tagline">BODY &nbsp;·&nbsp; PAINT &nbsp;·&nbsp; DETAILING</span>
      </div>
    </div>

  </v-app>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      navLinks: [
        { to: '/home',     label: 'Home' },
        { to: '/services', label: 'Services' },
        { to: '/gallery',  label: 'Gallery' },
        { to: '/contact',  label: 'Contact' },
      ]
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Poppins:wght@700;800;900&display=swap');

*, *::before, *::after { box-sizing: border-box; }

body, html {
  font-family: 'Inter', sans-serif !important;
  background: #0d0d0d !important;
  margin: 0;
  padding: 0;
}

.v-application { background: #0d0d0d !important; }
.v-application--wrap {
  min-height: 100vh !important;
  display: flex !important;
  flex-direction: column !important;
}

/* ── FIXED HEADER ── */
.site-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
}

/* Top Bar */
.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #161616;
  border-bottom: 1px solid rgba(204,0,0,0.2);
  padding: 0 40px;
  height: 36px;
  font-size: 12px;
  color: #777;
  letter-spacing: 0.3px;
  flex-shrink: 0;
}

/* Navbar */
.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #111111;
  border-bottom: 2px solid #cc0000;
  padding: 0 40px;
  height: 90px;
  flex-shrink: 0;
}

.navbar-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.navbar-right {
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Logo */
.nav-logo {
  height: 74px;
  width: 74px;
  object-fit: contain;
  border-radius: 12px;
  background: #ffffff;
  padding: 5px;
  display: block;
  flex-shrink: 0;
}

/* Brand */
.brand-white {
  font-family: 'Poppins', sans-serif;
  font-weight: 800;
  font-size: 21px;
  color: #ffffff;
  letter-spacing: 2px;
}

.brand-red {
  font-family: 'Poppins', sans-serif;
  font-weight: 800;
  font-size: 21px;
  color: #cc0000;
  letter-spacing: 2px;
}

/* Nav links */
.v-application a.nav-link,
.v-application a.nav-link:visited {
  color: #ffffff !important;
}

.nav-link {
  color: #ffffff !important;
  text-decoration: none;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
  padding: 8px 16px;
  position: relative;
  white-space: nowrap;
  transition: color 0.2s;
}

.nav-link:hover { color: #cc0000 !important; }

.nav-link--active,
.router-link-active.nav-link,
.router-link-exact-active.nav-link {
  color: #ffffff !important;
}

.nav-link--active::after,
.router-link-exact-active.nav-link::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 16px;
  right: 16px;
  height: 3px;
  background: #cc0000;
  border-radius: 2px;
}

/* ── CONTENT ── */
.site-content {
  margin-top: 126px; /* 36px topbar + 90px navbar */
  background: #0d0d0d;
  flex: 1;
}

/* ── FOOTER ── */
.site-footer {
  background: #0a0a0a;
  border-top: 1px solid rgba(204,0,0,0.25);
}

.footer-top {
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1fr;
  gap: 48px;
  padding: 56px 40px 48px;
}

.footer-brand {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.footer-logo {
  height: 90px;
  width: 90px;
  object-fit: contain;
  border-radius: 12px;
  background: #fff;
  padding: 5px;
}

.footer-brand-desc {
  font-size: 13.5px;
  color: #666;
  line-height: 1.75;
  margin: 0;
  max-width: 280px;
}

.footer-gujarati {
  font-size: 13px;
  font-weight: 600;
  color: #cc0000;
}

.footer-col {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-col-title {
  font-size: 11.5px;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.v-application a.footer-link,
.v-application a.footer-link:visited {
  color: #666 !important;
}

.footer-link {
  font-size: 13.5px;
  color: #666 !important;
  text-decoration: none;
  transition: color 0.2s;
}
.footer-link:hover { color: #cc0000 !important; }

.footer-address {
  font-size: 13.5px;
  color: #666;
  line-height: 1.6;
}

.footer-hours {
  font-size: 13.5px;
  color: #666;
}

.footer-bottom {
  border-top: 1px solid rgba(255,255,255,0.06);
  padding: 18px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.footer-copy {
  font-size: 12px;
  color: #444;
}

.footer-tagline {
  font-size: 11px;
  font-weight: 700;
  color: #333;
  letter-spacing: 2px;
  text-transform: uppercase;
}
</style>
